<template>
    <div id="app">
        <router-view/>
        <TheSpinner v-if="showSpinner" />
    </div>
</template>

<script>
import TheSpinner from '../../components/layouts/TheSpinner.vue';

export default {
    name: 'App',
    components: {
        TheSpinner
    },
    data() {
        return {
            showSpinner: false
        }
    },
    provide() {
        return {
            setShowGlobalSpinner: this.setShowSpinner
        }
    },
    methods: {
        setShowSpinner(val) {
            this.showSpinner = val;
        }
    }
}

</script>